import React from 'react';
import GlobalLayout from '../GlobalLayout';

export default ({ children }) => (
	<GlobalLayout>
		<div className="px-4 py-4 sm:px-6 md:px-8">{children}</div>
	</GlobalLayout>
);
